<template>
  <div>
    <NavTop class="navbar"></NavTop>
    <div class="whole">
      <DetailedPage></DetailedPage>
      <keep-alive>
      <div class="box">
        <div class="box_title">
          <div class="box_title_l">{{ title }}</div>
          <div class="box_title_r">
            <span class="title_r_span1" @click="navigateTo('/')">首页</span>
            <span>/{{title}}</span>
<!--            <span v-if="navInfo.length == 1" class="title_r_span3" v-for="(item,index) in navInfo"-->
<!--                  :key="index">/{{ item.name }}</span>-->
<!--            <span v-if="navInfo.length > 1" class="title_r_span2" :class="index == 1?'active1':''"-->
<!--                  @click="navTO(item,index)"-->
<!--                  v-for="(item,index) in navInfo"-->
<!--                  :key="index">/{{ item.name }}</span>-->
          </div>
        </div>
        <div class="news" style="cursor: pointer" v-for="(item,index) in newsList" :key="index"
             @click="routerpushV('/common/detail',item.tabBarId,item.id)">
          <div class="new_title">{{ item.title }}</div>
          <div class="new_date">{{ extractDate(item.publishTime) }}</div>
        </div>
        <div style="border-top:1px solid #ccc;"></div>
      </div>
      </keep-alive>
    </div>
    <div style="width: 100%;display: flex;justify-content: center; margin-top: 20px;  margin-bottom: 80px">
      <el-pagination v-if="total > pageSize" v-model="pageNum" @current-change="clickPage" :page-size="pageSize"
                     background
                     layout="prev, pager, next"
                     :total="total"/>
    </div>
  </div>
</template>

<script>
import home from '../../../api/home.js'

export default {
  data () {
    return {
      // 页数
      pageNum: 1,
      // 每页数量
      pageSize: 15,
      // 总条数
      total: 0,
      // 标题
      title: '学校首页新闻',
      // 二
      two: {
        to: '',
        text: '网站首页管理'
      },
      // 三
      three: {
        to: '',
        text: '/学校首页新闻'
      },
      // 列表数据
      newsList: [],
      // 导航信息
      navInfo: []
    }
  },
  created () {
    // 初始化页码
    // this.pageNum = 3
    // window.location.reload()
    console.log(this.pageNum)
    // 循环数据
    this.XUnHuan(this.$route.params.tabBarId)
    // 获取列表
    this.getList(this.$route.params.tabBarId, this.pageNum, this.pageSize)
    // 获取导航栏
    this.getTabBar(this.$route.params.tabBarId)
  },
  watch: {
    // 使用字符串路径监听
    '$route.params.tabBarId': function (newVal, oldVal) {
      // 当 $route.params.val 发生变化时，这个函数会被调用
      console.log(newVal, 'lllll')
      // 在这里处理变化
      this.getList(newVal, this.pageNum, this.pageSize)
      this.getTabBar(newVal)
      window.location.reload()

    },
    '$route': function (newRoute, oldRoute) {
      // 路由变化时执行的操作
      // this.pagePath = this.removeAfterFirstNumber(this.$route.path)
      console.log(this.$route.path, 'pathpathpath')
    }
  },
  methods: {
    // 点击导航栏跳转
    navTO (item, index) {
      if (index == 0) {
        this.$router.push(item.path + '/' + item.id)
      }
    },
    // 获取导航栏
    async getTabBar (id) {
      try {
        const res = await home.getTarBarInfo({id})
        if (id == 64 || id == 65 || id == 67 || id == 212 || id == 18 || id == 15) {
          let data = res.data.slice(0, 2)
          this.navInfo = data.slice().reverse()
          this.title = res.data[0].name
          console.log(this.navInfo, 'lll')
          console.log(this.title, 'pppp')
          return
        }
        this.navInfo = res.data.slice().reverse()
        this.title = res.data[0].name
      } catch (e) {
        console.log(e)
      }
    },
    // 查询文章列表
    async getList (tabBarId, pageNum, pageSize) {
      try {
        if (tabBarId == 34) {
          const res = await home.getWenZhang({tabBarId: 64, pageNum, pageSize})
          this.newsList = res.rows
          this.total = res.total
          return
        }
        const res = await home.getWenZhang({tabBarId, pageNum, pageSize})
        this.newsList = res.rows
        this.total = res.total
      } catch (e) {
        console.log(e)
      }
    },
    // 点击分页
    clickPage (e) {
      this.pageNum = e
      this.getList(this.$route.params.tabBarId, this.pageNum, this.pageSize)
    },
    // 跳转
    navigateTo (path, text) {
      console.log(path, text)
      if (text) {
        if (text == '网站首页管理') {
          this.$router.push(path + '/' + 0)
          this.title = '网站首页管理'
          this.two.text = '河北东方学院'
          this.three.text = '/网站首页管理'
          return
        }
        if (text == '河北东方学院') {
          this.$router.push(path + '/' + 1)
          this.title = '河北东方学院'
          this.two.text = ''
          this.three.text = '河北东方学院'
          return
        }
      }
      this.$router.push(path)
    },
    // 提取日期
    extractDate (dateTimeStr) {
      // 检查dateTimeStr是否为null或undefined
      if (!dateTimeStr) {
        console.log('dateTimeStr is null or undefined')
        return '' // 或者返回一个默认值，或者处理错误
      }
      // 假设日期时间格式总是 "YYYY-MM-DD HH:MM:SS"
      // 使用 split 方法按空格分割日期和时间
      const [date, time] = dateTimeStr.split(' ')
      // 返回日期部分
      return date
    },
    // 循环改变标题
    XUnHuan (val) {
      console.log(val, 'valval')
      let that = this
      switch (val) {
        case '64':
          that.title = '学校首页新闻'
          that.two.text = '网站首页管理'
          that.three.text = '/学校首页新闻'
          break
        case '65':
          that.title = '通知公告'
          that.two.text = '河北东方学院'
          that.three.text = '/通知公告'
          break
        case '67':
          that.title = '产学研用'
          that.two.text = '河北东方学院'
          that.three.text = '/产学研用'
          break
      }
    },
    // 跳转
    routerpushV (path, tabBarId, id) {
      if (tabBarId) {
        this.$router.push({path: path + '/' + tabBarId + '/' + id})
        return
      }
      this.$router.push({path: path})
    }
  }
}
</script>
<style lang="less" scoped>
.nav:hover {
  background-color: #9E070E;
}

.news {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 20px;
  margin-top: 20px;
  padding-top: 10px;

  .new_title {
    width: 80%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 16px;
    color: #444;
    cursor: pointer;

    &:hover {
      color: #9E070E;
    }
  }

  .new_date {
    width: 20%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 14px;
    text-align: right;
    color: #444;
  }
}

.news:hover {
  color: #9e070e;
}

.whole {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}

.box {
  width: 960px;
  padding-top: 50px;
}

.box_title {
  width: 960px;
  height: 45px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;

  .box_title_l {
    padding: 0 15px;
    line-height: 45px;
    font-size: 20px;
    font-weight: bold;
    color: #444;
    border-bottom: 2px solid #9e070e;
  }

  .box_title_r {
    font-size: 14px;
    color: #666;

    .title_r_span1 {
      cursor: pointer;
      color: #666;

      &:hover {
        text-decoration: underline;
      }
    }

    .title_r_span2 {
      cursor: pointer;
      color: #666;

      &:hover {
        text-decoration: underline;
      }
    }

    .title_r_span3 {
      cursor: pointer;
      color: #666;
    }
  }
}

.active1 {
  cursor: pointer;
  color: #666;

  &:hover {
    text-decoration: none !important;
    cursor: text !important;
  }
}
</style>
<style lang="less">
.el-pager {
  .number:hover {
    background-color: #8D080E !important;
    color: #fff !important;
  }
}

.active {
  background-color: #8D080E !important;
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/views/common/more/more.vue